import { DesktopHeader } from "./desktop-header.js";
import { MobileHeader } from "./mobile-header.js";
import { useMediaQuery } from "../utilities/index.js";
import { useTheme } from "@mui/material";
import React from "react";
export const Header = (props) => {
    const theme = useTheme();
    const useDesktopNavigation = useMediaQuery(theme.breakpoints.up("md"));
    return useDesktopNavigation ? React.createElement(DesktopHeader, { ...props }) : React.createElement(MobileHeader, { ...props });
};
//# sourceMappingURL=header.js.map